import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import api from '../api';
import NewsCard from '../components/NewsCard';
import SEO from '../components/SEO';
import StructuredData, { createBreadcrumbSchema } from '../components/StructuredData';
import './CategoryPage.css';

function CategoryPage() {
  const { category } = useParams();
  const [news, setNews] = useState([]);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  useEffect(() => {
    const fetchNews = async () => {
      try {
        setLoading(true);
        let response;
        if (category === 'ujala-gallery') {
          response = await api.get(`/api/news/ujala-gallery?page=${page}&limit=12`);
        } else if (category === 'ujala-events') {
          response = await api.get(`/api/news/ujala-events?page=${page}&limit=12`);
        } else {
          response = await api.get(`/api/news?category=${category}&page=${page}&limit=12`);
        }
        if (response && response.data && response.data.success) {
          setNews(response.data.data);
          setTotalPages(response.data.pagination ? response.data.pagination.pages : 1);
        }
      } catch (error) {
        console.error('Error fetching category news:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchNews();
  }, [category, page]);

  const handlePrevPage = () => {
    if (page > 1) {
      setPage(page - 1);
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  const handleNextPage = () => {
    if (page < totalPages) {
      setPage(page + 1);
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  if (loading) {
    return (
      <div className="loading">
        <div className="spinner"></div>
      </div>
    );
  }

  // Create breadcrumb schema
  const breadcrumbSchema = createBreadcrumbSchema([
    { name: 'होम', url: '/' },
    { name: category }
  ]);

  return (
    <div className="category-page">
      {/* SEO Meta Tags */}
      <SEO
        title={`${category.toUpperCase()} की खबरें - RR NEWS TV FASTEST UPDATE`}
        description={`RR NEWS TV FASTEST UPDATE पर ${category} से जुड़ी सभी ताज़ा खबरें, ब्रेकिंग न्यूज़ और अपडेट्स हिंदी में पढ़ें`}
        keywords={`${category}, मुरादाबाद, उजाला, समाचार, ${category} news`}
        url={`/category/${category}`}
        type="website"
      />
      
      {/* Structured Data */}
      <StructuredData data={breadcrumbSchema} />
      
      <div className="container">
        <h1 className="page-title">
          📁 {category.toUpperCase()} की खबरें
        </h1>

        {news.length === 0 ? (
          <div className="no-news">
            <p>इस श्रेणी में कोई खबर उपलब्ध नहीं है।</p>
          </div>
        ) : (
          <>
            <div className="news-grid">
              {news.map((item) => (
                <NewsCard key={item._id} news={item} />
              ))}
            </div>

            {totalPages > 1 && (
              <div className="pagination">
                <button 
                  onClick={handlePrevPage} 
                  disabled={page === 1}
                  className="pagination-btn"
                >
                  ← पिछला
                </button>
                <span className="page-info">
                  पेज {page} / {totalPages}
                </span>
                <button 
                  onClick={handleNextPage} 
                  disabled={page === totalPages}
                  className="pagination-btn"
                >
                  अगला →
                </button>
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
}

export default CategoryPage;


